


















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import CircularCountdown from "../Widgets/CircularCountdown/CircularCountdown.vue";
// @ts-ignore
import store from "../../store";
import {Tasks} from "../../../types/tasks";
import MessageHelper from "../../helpers/MessageHelper";

@Component({
    components: {CircularCountdown},
    props: {},
})

export default class SuggestModal extends Vue {
    @Prop({ required: true }) private readonly data!: Record<string, string|number>

    private get currentPlayerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * Имя игрока
     * @private
     */
    private get playerName(): string
    {
        if (!store.getters.getPlayerGameDataById(this.data.playerId)) {
            return 'Player';
        }
        return store.getters.getPlayerGameDataById(this.data.playerId).name;
    }

    /**
     * Цвет игрока
     * @private
     */
    private get playerColor(): string
    {
        if (!store.getters.getPlayerDataById(this.data.playerId)) {
            return '';
        }
        return store.getters.getPlayerDataById(this.data.playerId).color.code;
    }

    /**
     * Текущая игра
     */
    private get currentActivity(): null | Tasks.TActivity
    {
        if (!store.getters.getActivityById(this.data.activityId)) {
            return null;
        }
        return store.getters.getActivityById(this.data.activityId);
    }

    /**
     * Название игры
     */
    private get activityName(): string
    {
        if (!this.currentActivity) {
            return '';
        }
        return this.currentActivity.name;
    }

    /**
     * Постер игры
     */
    private get activityPoster(): string
    {
        if (!this.currentActivity) {
            return '';
        }
        return this.currentActivity.image;
    }

    /**
     * Принять игру
     * @private
     */
    private acceptGame(): void
    {
        this.$emit('close');
        MessageHelper.acceptGameSuggestion({
            playerId: this.currentPlayerId,
            activityId: this.currentActivity?.id
        });
    }

    /**
     * Отклонить игру
     * @private
     */
    private rejectGame(): void
    {
        this.$emit('close');
        MessageHelper.rejectGameSuggestion({
            playerId: this.currentPlayerId,
            activityId: this.currentActivity?.id
        });
    }
}
